import { queryOptions, useQuery } from '@tanstack/react-query';
import { JobsiteService } from '../generated';

export const jobsiteKeys = {
  base: ['jobsite'],
  list: ({ organisationId }: JobsiteListOptionsProps) => [...jobsiteKeys.base, organisationId, 'list'] as const,
};

export interface JobsiteListOptionsProps {
  organisationId: string | undefined;
}

export function jobsiteListOptions({ organisationId }: JobsiteListOptionsProps) {
  return queryOptions({
    queryKey: jobsiteKeys.list({ organisationId }),
    queryFn: async () => {
      if (!organisationId) {
        throw new Error('organisationId is required');
      }

      const response = await JobsiteService.jobsiteControllerGetJobsites({
        path: {
          organisationId: organisationId,
        },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!organisationId,
  });
}

export function useJobsiteList(props: JobsiteListOptionsProps) {
  return useQuery(jobsiteListOptions(props));
}
